<template>
  <div>
    <PageHeader title="Alta de cargas" :breadcrum-routes="pageHeaderRoutes">
      <template #tags>
        <a-tag
          :color="
            stateTag === 'EJECUTADO'
              ? 'success'
              : stateTag === 'CANCELADO'
                ? 'error'
                : stateTag === 'EN RESOLICITUD' ||
                    stateTag === 'EN CORREDORA' ||
                    stateTag === 'EN ASEGURADORA'
                  ? 'warning'
                  : 'processing'
          "
        >
          {{ stateTag }}
        </a-tag>
        <a-tag color="processing">ID: {{ ticketId }}</a-tag>
      </template>
      <template v-if="userRole != 'rrhh'" #buttons>
        <a-button
          v-if="stateTag != 'CANCELADO' && stateTag != 'EJECUTADO'"
          @click="openCancelModal"
          :loading="loading"
        >
          Cancelar
        </a-button>
        <a-button
          class="ml-1"
          type="primary"
          @click="openReviewModal"
          :loading="loading"
          v-if="stateTag === 'EN CORREDORA'"
        >
          Revisado
        </a-button>
        <a-button
          class="ml-1"
          type="primary"
          @click="openFinishModal"
          :loading="loading"
          v-if="stateTag === 'EN ASEGURADORA'"
        >
          Ejecutar
        </a-button>
      </template>

      <template #content-below-title>
        <div
          v-if="ticketGroupIdValue"
          style="margin-top: 0px; font-size: 14px"
          class="ant-page-header-content"
        >
          <a-button
            type="primary"
            class="mb-0"
            @click="goToTicketGroup(ticketGroupIdValue)"
          >
            Ticket masivo: #{{ ticketGroupIdValue }}
          </a-button>
        </div>
      </template>
    </PageHeader>

    <StepperState v-bind="stepperData" />
    <a-card class="mt-3">
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :md="12">
          <TicketData v-bind="ticketDetails">
            <template
              v-if="
                userRole != 'rrhh' &&
                (stateTag === 'EN CORREDORA' || stateTag === 'EN ASEGURADORA')
              "
              #action
            >
              <a-tooltip>
                <template #title>Editar</template>
                <a-button @click="openAltaEditModal">
                  <template #icon><edit-outlined /></template>
                </a-button>
              </a-tooltip>

              <AltaEditModal
                :values="altaEditObject"
                :ticketId="Number(ticketId)"
                @editedAltaColaborator="() => getTicketData()"
                ref="editModalRef"
                :rentRequired="employeeRentRequired"
              />
            </template>
          </TicketData>

          <a-card
            class="mt-3"
            v-if="userRole != 'rrhh'"
            title="Casos asociados"
            bodyStyle="padding: 24px 24px 24px 24px; border: 1px solid #f0f0f0; border-top-width: 0px;"
            :bordered="false"
          >
            <div v-if="cases.length == 0">
              <a-typography-text>No existen casos</a-typography-text>
            </div>

            <a-row
              type="flex"
              justify="space-between"
              v-for="c in cases"
              :key="c.id"
            >
              <a-col :span="6">
                <a-typography-text>{{ c.state }}</a-typography-text>
              </a-col>
              <a-col>
                <tags :stateId="c.tag" />
              </a-col>
              <a-col>
                <a-button type="link" @click="redirectCase(c)">
                  Ir a caso
                </a-button>
              </a-col>
              <a-divider class="my-2" v-if="cases.length > 1" />
            </a-row>
          </a-card>
        </a-col>
        <a-col :xs="24" :md="12">
          <Records v-bind="recordsData" />

          <a-table
            class="mt-3"
            v-if="userRole != 'rrhh'"
            :row-selection="rowSelectionForm"
            :selections="true"
            :columns="columnsFiles"
            :data-source="files"
            :showHeader="false"
            :pagination="false"
            :loading="loadingFiles"
          >
            <template #title>Archivos adjuntos</template>
            <template #options="{ text: options }">
              <span style="display: flex">
                <a-tooltip color="#05045D" title="Ver más">
                  <a-button type="link" :disabled="options.requestCounter > 0">
                    <eye-outlined
                      @click="() => redirectToFile(options.seeMore)"
                    />
                  </a-button>
                </a-tooltip>
                <a-tooltip color="#05045D" title="Resolicitar">
                  <a-button
                    type="link"
                    @click="() => openReapplyModal(options.fileId)"
                    :disabled="!options.canRequest"
                  >
                    <mail-outlined />
                  </a-button>
                </a-tooltip>
                <a-tooltip
                  color="#05045D"
                  title="Historial"
                  @click="
                    () => openAttachedDocumentsHistoryModal(options.fileId)
                  "
                >
                  <a-button type="link">
                    <clock-circle-outlined />
                  </a-button>
                </a-tooltip>
              </span>
            </template>
          </a-table>

          <attached-documents
            v-if="userRole != 'rrhh' && ticketOptionalFiles.length > 0"
            class="mt-3"
            title="Archivos opcionales"
            :data="ticketOptionalFiles"
            :loading="loadingOptionalFiles"
          />

          <div class="mt-3">
            <dependants-incorporations-table />
          </div>

          <mensaje-aseguradora
            v-if="userRole != 'rrhh'"
            class="mt-3"
            :message="insuranceMessage"
          />

          <Comments
            class="mt-3"
            v-if="userRole != 'rrhh'"
            :idToTicket="ticketId"
            :comments="comments"
            @new_comment="getNewCommment"
          />
        </a-col>
      </a-row>
    </a-card>

    <attached-documents-history ref="attachedDocumentsHistoryRef" />

    <!-- Resolicitud de documento -->
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showReapplyDoc"
      centered
      @cancel="closeReapplyModal"
      title="Resolicitud de documento"
      :closable="!loadingReapply"
      :maskClosable="!loadingReapply"
    >
      <h3><b>Escribe un mensaje para el colaborador</b></h3>
      <p>
        Recordatorio Nombre:
        {{ employeeData?.employee?.fullname }}
      </p>

      <a-textarea
        v-model:value="reapplyText"
        placeholder="Escribe aquí el mensaje para el colaborador"
        :autoSize="{ minRows: 5, maxRows: 5 }"
      />

      <template #footer>
        <a-button
          key="back"
          @click="closeReapplyModal"
          :disabled="loadingReapply"
        >
          Cancelar
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingReapply"
          :disabled="reapplyButtonBlocked"
          @click="documentReapply(idReapplyDocument)"
        >
          Enviar
        </a-button>
      </template>
    </a-modal>

    <!-- Modal Success -->
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showSucess"
      centered
      footer=""
      :title="successTitle"
    >
      <a-result status="success" :title="successMessage"></a-result>
    </a-modal>

    <!-- Modal Error -->
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showError"
      centered
      footer=""
      :title="errorTitle"
    >
      <a-result status="error" :title="errorMessage"></a-result>
    </a-modal>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, ref, createVNode } from 'vue';
import {
  ClockCircleOutlined,
  EyeOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
  EditOutlined
} from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import AltaEditModal from '@/components/tickets/incorporation-edit-modal.vue';
import openNotificationWithIcon from '@/utils/notifications';
import AttachedDocumentsHistory from '@/components/attached-documents-history.vue';
import notification from '@/utils/notifications';
import rutFormatter from '@/utils/Ruts';
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import StepperState from '@/components/stepper-state.vue';
import TicketData from '@/components/tickets/ticket-data.vue';
import Comments from '@/components/tickets/comments.vue';
import Records from '@/components/tickets/records.vue';
import DateFormmater from '@/utils/dateFormatter';
import parseDate from '@/utils/dateFormatter';
import DependantsIncorporationsTable from '@/new-components/ticket/dependants-incorporation/dependants-incorporations-table.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
import {
  FETCH_TICKET,
  FETCH_TICKET_ID,
  FETCH_CASES,
  FETCH_EMPLOYEE_TICKET,
  FETCH_TICKET_COMMENTS_ID,
  FETCH_USER_BY_ID,
  POST_CANCEL_DEPENDENTS_INCORPORATION,
  POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION,
  POST_FINISH_DEPENDENTS_INCORPORATION,
  FETCH_TICKET_AVAILABLE_COVERAGES,
  FETCH_FILE_BY_TICKET,
  PUT_REAPPLY_FILE,
  FETCH_TICKET_DEPENDANTS_INCORPORATIONS,
  FETCH_EMPLOYEE_COMPANY_RENT,
  FETCH_TICKET_INCOME,
  FETCH_TICKET_OPTIONAL_FILES,
  GET_TICKET_OPTIONAL_FILES,
  GET_LOGGED_USER
} from '@/store/types';
import moment from 'moment';

const store = useStore();
const route = useRoute();
const router = useRouter();
const ticketId = route.params.id;
const STATUS_SEND_TO_INSURANCE = 8;
const STATUS_FINISHED = 3;
const STATUS_CANCELLED = 4;
const loading = ref(false);
const employeeData = ref({});
const brokerName = ref('');
const showSucess = ref(false);
const successTitle = ref('');
const successMessage = ref('');
const showError = ref(false);
const errorTitle = ref('');
const errorMessage = ref('');
const userRole = store.getters[GET_LOGGED_USER].roleName;
const goToTicketGroup = (id) => {
  router.push({
    name: 'AltaCargasMasivaDetalle',
    params: { id }
  });
};
const openReviewModal = () => {
  Modal.confirm({
    title: () =>
      '¿Estás seguro que deseas enviar el alta de cargas a la compañía aseguradora?',
    icon: () => createVNode(ExclamationCircleOutlined),
    okText: () => 'Sí',
    cancelText: () => 'No',
    onOk() {
      finishSelection();
    },
    onCancel() {}
  });
};

const openCancelModal = () => {
  Modal.confirm({
    title: () => '¿Estás seguro que deseas cancelar el alta de cargas?',
    icon: () => createVNode(ExclamationCircleOutlined),
    okText: () => 'Sí',
    cancelText: () => 'No',
    onOk() {
      cancelTicket();
    },
    onCancel() {}
  });
};

const openFinishModal = () => {
  Modal.confirm({
    title: () => '¿Estás seguro que deseas ejecutar el alta de cargas?',
    icon: () => createVNode(ExclamationCircleOutlined),
    okText: () => 'Sí',
    cancelText: () => 'No',
    onOk() {
      finishTicket();
    },
    onCancel() {}
  });
};

const redirectToFile = (url) => {
  window.open(url, '_blank');
};

const attachedDocumentsHistoryRef = ref();
const openAttachedDocumentsHistoryModal = (id) => {
  attachedDocumentsHistoryRef.value.openModal(id);
};

// * Page Header
const pageHeaderRoutes = [
  {
    path: '/altas-cargas',
    breadcrumbName: 'Altas cargas'
  },
  {
    path: '#',
    breadcrumbName: 'Individual'
  },
  {
    breadcrumbName: `#${ticketId}`
  }
];

const stateTag = computed(() => {
  const { states } = ticketData.value;
  const map = {
    1: 'CREADO',
    7: 'EN CORREDORA',
    8: 'EN ASEGURADORA',
    3: 'EJECUTADO',
    4: 'CANCELADO',
    5: 'EJECUTADO'
  };
  if (files.value.some((f) => f.options.requestCounter > 0))
    return 'EN RESOLICITUD';
  if (states) {
    return map[states[states.length - 1].state.id];
  }
  return 'vacio';
});

// * Stepper State
const stepperData = computed(() => {
  const { states } = ticketData.value;

  const stateLabels = {
    1: 'Creado',
    7: 'En revisión corredora',
    8: 'En revisión aseguradora',
    3: 'Ejecutado',
    5: 'Ejecutado'
  };

  // Standard flow for alta (dependants are always alta type)
  const standardFlow = [1, 7, 8, 3];

  let isCancelled = false;
  let current = 0;
  const data = [];

  if (states) {
    // Check if the ticket was cancelled (last state id === 4)
    const lastState = states[states.length - 1];
    isCancelled = lastState?.state?.id === 4;

    // Build map of which states the ticket actually reached (exclude cancel)
    const historyMap = {};
    states.forEach((s) => {
      if (s.state.id !== 4) {
        historyMap[s.state.id] = s.createdAt;
      }
    });

    const reachedIds = new Set(Object.keys(historyMap).map(Number));

    // Pass 1: add all reached states (in standard flow order)
    let lastReachedFlowIdx = -1;
    let reachedCount = 0;
    standardFlow.forEach((stateId, flowIdx) => {
      const title = stateLabels[stateId];
      if (!title) return;

      if (reachedIds.has(stateId)) {
        data.push({
          index: stateId,
          title,
          description: parseDate(historyMap[stateId])
        });
        lastReachedFlowIdx = flowIdx;
        reachedCount++;
      }
    });

    // Pass 2: add future states (after last reached, not yet in data)
    for (let i = lastReachedFlowIdx + 1; i < standardFlow.length; i++) {
      const stateId = standardFlow[i];
      const title = stateLabels[stateId];
      if (title && !reachedIds.has(stateId)) {
        data.push({
          index: stateId,
          title,
          description: ''
        });
      }
    }

    // Current = index of the last reached state
    // (when cancelled, this step shows error/X instead of process via isCancelled flag)
    current = Math.max(0, reachedCount - 1);
  }

  return {
    data,
    isCancelled,
    current
  };
});

// * Ticket data
const ticketDetails = computed(() => {
  const { fullname, rut, email } = employeeData?.value?.employee || {};
  const { startDate, broker, company, insuranceCompany, policies } =
    ticketData?.value || {};

  return {
    title: 'Datos ticket',
    data: [
      {
        key: 'Ejecutivo',
        value: broker?.name
      },
      {
        key: 'Fecha de inicio de vigencia',
        value: moment(startDate).format('DD/MM/YYYY')
      },
      {
        key: 'Nombre completo',
        value: fullname
      },
      {
        key: 'RUT',
        value: rutFormatter.formatRut(rut)
      },
      {
        key: 'Correo',
        value: email
      },
      {
        key: 'Empresa',
        value: company?.businessName
      },
      {
        key: 'Aseguradora',
        value: insuranceCompany?.businessName
      },
      {
        key: 'Pólizas',
        value: policies?.map((p) => p?.numberPolicy).join(', ')
      }
    ],
    loadTicket: false
  };
});

const insuranceMessage = ref('');

// * Comentarios
const comments = ref([]);

const getNewCommment = (value) => {
  comments.value.push({
    description: parseDate(value.description),
    title: value.title,
    author: brokerName.value,
    date: value.description
  });
};

const getCommentsByTicketId = async () => {
  const response_comments = await store
    .dispatch(FETCH_TICKET_COMMENTS_ID, ticketId)
    .catch((e) => e.response);

  for (let i = 0; i < response_comments.data.length; i++) {
    const element = response_comments.data[i];
    const brokerName = await getBroker(response_comments.data[i].brokerId);
    comments.value.push({
      description: parseDate(element.createdAt),
      title: element.message,
      author: brokerName,
      date: element.createdAt
    });
  }
};

const getBroker = async (id) => {
  const response = await store.dispatch(FETCH_USER_BY_ID, id);
  return response.data.body.name;
};

// * Historial
const recordsData = computed(() => {
  const formattedStates =
    ticketData.value.states?.map((state) => ({
      title: state?.state?.tag,
      description: state?.createdAt ? new Date(state.createdAt) : ''
    })) || [];

  const formattedComments =
    comments.value?.map((comment) => ({
      title: 'Nuevo comentario',
      description: comment?.date ? new Date(comment.date) : ''
    })) || [];

  const records = [...formattedStates, ...formattedComments];

  const orderedRecords = records?.sort(
    (a, b) => a?.description - b?.description
  );

  return {
    title: 'Historial',
    loading: false,
    data: orderedRecords?.map((record) => ({
      title: record?.title,
      description: record?.description ? DateFormmater(record.description) : ''
    }))
  };
});

// * Documentos
const files = ref([]);
const loadingFiles = ref(true);
const ticketOptionalFiles = ref([]);
const loadingOptionalFiles = ref(false);

const getTicketOptionalFiles = async () => {
  loadingOptionalFiles.value = true;
  try {
    if (userRole != 'rrhh') {
      await store.dispatch(FETCH_TICKET_OPTIONAL_FILES, ticketId);
    }
    ticketOptionalFiles.value = await store.getters[GET_TICKET_OPTIONAL_FILES];
    loadingOptionalFiles.value = false;
  } catch (error) {
    openNotificationWithIcon(
      'error',
      'Error',
      `Error al cargar archivos opcionales del Ticket ${ticketId}. ${error}`
    );
    loadingOptionalFiles.value = false;
  }
};

const ticketGroupIdValue = computed(() => ticketData.value?.ticketGroupId);

const getDocumentsByTicketId = async () => {
  loadingFiles.value = true;
  try {
    files.value.length = 0;

    const responseFiles = await store.dispatch(FETCH_FILE_BY_TICKET, ticketId);

    for (let i = 0; i < responseFiles.data.length; i++) {
      const element = responseFiles.data[i];

      const obj = {
        key: i + 1,
        id: element.id,
        name: element.name,
        company: ticketData.value.insuranceCompany.businessName,
        status: true,
        options: {
          seeMore: element.ticketFileUrl,
          fileId: element.id,
          canRequest:
            element.fileInsuranceCompanyId != null &&
            stateTag.value === 'EN CORREDORA',
          requestCounter: element.requestCounter
        }
      };
      files.value.push(obj);
    }

    loadingFiles.value = false;
  } catch (error) {
    console.error(error);
    loadingFiles.value = false;
  }
};

// Casos

const cases = ref([]);

const getAllCasesByTicketId = async () => {
  cases.value = [];

  const responseCases = await store
    .dispatch(FETCH_CASES, ticketId)
    .catch((e) => e.response);

  for (let i = 0; i < responseCases.data.length; i++) {
    const obj = {
      id: '',
      tag: '',
      state: '',
      typeCaseId: 0
    };

    const caso = responseCases.data[i];

    obj.id = caso.id;
    obj.tag = caso.states
      .sort((a, b) => {
        return b.id - a.id;
      })[0]
      .state.id.toString();
    obj.state = caso.typeCase.tag;
    obj.typeCaseId = caso.typeCaseId;

    cases.value.push(obj);
  }
};

const redirectCase = (value) => {
  const ticketId = value.id;

  const ticketType =
    value.state === 'Out of Time'
      ? 'fuera_de_tiempo'
      : value.state.toLowerCase();

  switch (ticketType) {
    case 'fuera de tiempo: alta individual de cargas':
      router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
      break;
  }
};

// Resolicitud de documentos
const showReapplyDoc = ref(false);
const idReapplyDocument = ref();
const reapplyText = ref(
  'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:'
);
const loadingReapply = ref(false);

const openReapplyModal = (idDocument) => {
  idReapplyDocument.value = idDocument;
  showReapplyDoc.value = true;
};

const closeReapplyModal = () => {
  idReapplyDocument.value = 0;
  showReapplyDoc.value = false;
  reapplyText.value =
    'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:';
};

const documentReapply = async (idDocument) => {
  loadingReapply.value = true;
  try {
    await store.dispatch(PUT_REAPPLY_FILE, {
      id: idDocument,
      payload: {
        message: reapplyText.value
      }
    });

    showSucess.value = true;
    successTitle.value = 'Mensaje enviado';
    successMessage.value = 'Su solicitud de documento a sido enviada con exito';
    reapplyText.value = '';
  } catch (error) {
    showError.value = true;
    errorTitle.value = 'Error';
    errorMessage.value = openNotificationWithIcon(
      'error',
      'Error',
      error.response.data
    );
  }
  loadingReapply.value = false;
  closeReapplyModal();
  getDocumentsByTicketId(ticketId);
};

const reapplyButtonBlocked = computed(() => {
  const backupText =
    'Estimado/a te informamos que recepcionamos tu formulario de incorporación y hemos detectado que se encuentra incompleto en la sección:';

  if (reapplyText.value != backupText && reapplyText.value != '') {
    return false;
  }

  return true;
});

const columnsFiles = [
  {
    dataIndex: 'name'
  },
  {
    dataIndex: 'company'
  },
  {
    dataIndex: 'options',
    slots: { customRender: 'options' }
  }
];

const changeCheckbox = (selectedRowKeys, selectedRows) => {
  idCheckbox.value.length = 0;
  for (let i = 0; i < selectedRows?.length; i += 1) {
    const element = selectedRows[i];
    idCheckbox.value.push(element.key);
  }
};
const idCheckbox = ref([]);

const getBackendErrorMessage = (error, fallback) => {
  return (
    error?.response?.data?.message || error?.response?.data?.error || fallback
  );
};

const fetchTicketAvailableCoverages = async () => {
  try {
    await store.dispatch(FETCH_TICKET_AVAILABLE_COVERAGES, ticketId);
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) {
      openNotificationWithIcon(
        'error',
        'Error',
        'No se encontró el ticket para obtener coberturas disponibles.'
      );
      return;
    }
    if (status === 409) {
      openNotificationWithIcon(
        'error',
        'Error',
        'El ticket no corresponde al tipo de alta de cargas (DEPENDENTS_INCORPORATION).'
      );
      return;
    }
    openNotificationWithIcon(
      'error',
      'Error',
      getBackendErrorMessage(
        error,
        'No se pudieron obtener las coberturas disponibles del ticket.'
      )
    );
  }
};

const getCheckbox = () => {
  if (stateTag.value === 'EN CORREDORA') {
    return {
      disabled: false
    };
  }
  return {
    disabled: true
  };
};
const rowSelectionForm = computed(() => {
  if (stateTag.value === 'EN CORREDORA') {
    return {
      onChange: changeCheckbox,
      getCheckboxProps: getCheckbox,
      selectedRowKeys: idCheckbox.value
    };
  }
  return {
    onChange: changeCheckbox,
    getCheckboxProps: getCheckbox
  };
});

// * Formularios
const finishTicket = async () => {
  loading.value = true;
  try {
    await store.dispatch(POST_FINISH_DEPENDENTS_INCORPORATION, {
      ticketId,
      status: STATUS_FINISHED
    });
    await getTicketData();
    openNotificationWithIcon(
      'success',
      'Correcto',
      'Alta de cargas ejecutado correctamente'
    );
  } catch (error) {
    openNotificationWithIcon(
      'error',
      'Error',
      getBackendErrorMessage(
        error,
        'Ocurrió un error al ejecutar el alta de cargas. Por favor inténtalo más tarde.'
      )
    );
  }
  loading.value = false;
};

const finishSelection = async () => {
  loading.value = true;

  if (idCheckbox.value.length != files.value.length) {
    notification('error', 'Error', 'Revise y confirme los archivos adjuntos');
    loading.value = false;
    return;
  }

  try {
    await store.dispatch(POST_SEND_TO_INSURANCE_DEPENDENTS_INCORPORATION, {
      ticketId,
      status: STATUS_SEND_TO_INSURANCE
    });
    await getTicketData();
    openNotificationWithIcon(
      'success',
      'Correcto',
      'Alta de cargas enviado a la aseguradora correctamente.'
    );
  } catch (error) {
    openNotificationWithIcon(
      'error',
      'Error',
      getBackendErrorMessage(
        error,
        'Ocurrió un error al enviar a la aseguradora. Por favor inténtalo más tarde.'
      )
    );
  }
  loading.value = false;
};

const cancelTicket = async () => {
  loading.value = true;

  try {
    await store.dispatch(POST_CANCEL_DEPENDENTS_INCORPORATION, {
      ticketId,
      status: STATUS_CANCELLED
    });
    await getTicketData();
    openNotificationWithIcon(
      'success',
      'Correcto',
      'Alta de cargas cancelado correctamente.'
    );
  } catch (error) {
    openNotificationWithIcon(
      'error',
      'Error',
      getBackendErrorMessage(
        error,
        'Ocurrió un error al cancelar el alta de cargas. Por favor inténtalo más tarde.'
      )
    );
  }
  loading.value = false;
};

// Obtención de data principal
const ticketData = ref({});
const getTicketData = () => {
  store
    .dispatch(FETCH_TICKET_ID, ticketId)
    .then((resp) => {
      const { data } = resp;
      ticketData.value = data;
      insuranceMessage.value = data.message;

      getBroker(ticketData.value.broker.id).then((resp) => {
        brokerName.value = resp;
      });

      getEmployeeIncome(
        ticketData.value.employee.id,
        ticketData.value.company.id
      );

      getDocumentsByTicketId();
    })
    .catch((err) => {
      console.log(err);
    });
};

const getEmployeeData = () => {
  store
    .dispatch(FETCH_EMPLOYEE_TICKET, ticketId)
    .then((resp) => {
      employeeData.value = resp.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

const altaEditObject = computed(() => {
  return {
    startDate: ticketData.value.startDate,
    firstName: ticketData.value.employee.firstName,
    secondName: ticketData.value.employee.secondName,
    firstSurname: ticketData.value.employee.firstSurname,
    secondSurname: ticketData.value.employee.secondSurname,
    birthdayDate: ticketData.value.employee.birthdayDate,
    rut: ticketData.value.employee.rut,
    email: ticketData.value.employee.email,
    incomeAmount: incomeAmount.value
  };
});

const incomeAmount = ref();
const getEmployeeIncome = (employeeId, companyId) => {
  store
    .dispatch(FETCH_EMPLOYEE_COMPANY_RENT, {
      employeeId: employeeId,
      companyId: companyId
    })
    .then((resp) => {
      if (resp.data != null) {
        incomeAmount.value = resp.data.incomeAmount;
      } else {
        incomeAmount.value = 0;
      }
    })
    .catch((error) => {
      notification('error', 'Error', error.response.data.messsage);
    });
};

const employeeRentRequired = ref(false);
const getRentRequirement = () => {
  store
    .dispatch(FETCH_TICKET_INCOME, ticketId)
    .then((resp) => {
      employeeRentRequired.value = resp.data.isIncomeRequired;
    })
    .catch((error) => {
      notification('error', 'Error', error.response.data.messsage);
    });
};

const editModalRef = ref();
const openAltaEditModal = () => {
  editModalRef.value.openModal();
};

onMounted(() => {
  store.dispatch(FETCH_TICKET, route.params.id);
  getTicketData();
  getEmployeeData();
  getCommentsByTicketId();
  getRentRequirement();
  getAllCasesByTicketId();
  getTicketOptionalFiles();
  store.dispatch(FETCH_TICKET_DEPENDANTS_INCORPORATIONS, route.params.id);
  fetchTicketAvailableCoverages();
});
</script>
